export default __webpack_public_path__ + "static/media/IMG_7571.a2896fbc.jpeg";